import React from "react";

const Footer = () => <footer style={{ marginBottom: 60 }} />;

export default Footer;
